var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"container-table"},[_c('div',{staticClass:"container-title"},[_vm._v("Pacientes")]),_c('PatientList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }